import React from 'react';

/**
 * True when the browser reports coarse pointer / no hover (typical touch UI).
 * Defaults to false until mounted to avoid hydration mismatch.
 */
function useTouchDevice(): boolean {
    const [isTouchDevice, setIsTouchDevice] = React.useState(false);

    React.useEffect(() => {
        const mqHoverNone = window.matchMedia('(hover: none)');
        const mqCoarse = window.matchMedia('(pointer: coarse)');
        const update = (): void => {
            setIsTouchDevice(mqHoverNone.matches || mqCoarse.matches);
        };
        update();
        mqHoverNone.addEventListener('change', update);
        mqCoarse.addEventListener('change', update);
        return () => {
            mqHoverNone.removeEventListener('change', update);
            mqCoarse.removeEventListener('change', update);
        };
    }, []);

    return isTouchDevice;
}

export default useTouchDevice;
